<template>
  <div class="order-list-index">
    <Search :renderData="renderData" :formData="form" :labelWidth="100" @onSearch="onSearch" ></Search>
    <Table
      :tableThData="tableThData"
      :tableTrData="tableTrData"
      :loading="loading"
      :limit="limit"
      :total="total"
      :offset="offset"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    >
      <template #paymentOrderId="{ row }">{{ row.paymentOrderId }}</template>
      <template #storeName="{ row }">{{ row.storeName }}</template>
      <template #mallName="{ row }">{{ row.mallName }}</template>
      <template #phone="{ row, scope }">
        <span :key="tableKey" v-if="row.phone">{{ row.phone_show || row.phone }}</span>
        <span :key="tableKey" v-else>---</span>
        <auth-button auth="user:phone:read">
          <el-button v-if="row.phone" class="look-phone-btn"  type="text" @click="onLookPhone(row, scope.$index)">
            {{ row.phone_show ? '隐藏' : '查看' }}
          </el-button>
        </auth-button>
      </template>
      <template #amount="{ row }">{{ row.amount }}</template>
      <template #actualAmount="{ row }">
        <span v-if="row.actualAmount || row.actualAmount === 0">{{ row.actualAmount }}</span>
        <span v-else>---</span>
      </template>
      <template #status="{ row }">
        <span :class="row.status + ' status'"></span>
        {{formatStatus(row.status)}}
      </template>
      <template #created="{ row }">{{ row.created ? $moment(row.created).format('YYYY/MM/DD HH:mm:ss') : '---' }}</template>
      <template #transactionId="{ row }">{{ row.transactionId }}</template>
      <template #source="{ row }">{{ row.source }}</template>
      <template #operation="{ scope }">
        <el-button type="text" @click="goDetail(scope.row)" >查看详情</el-button >
        <auth-button auth="paymentOrder:refund">
          <el-button class="refund" v-if="scope.row.refundAllow && scope.row.allowRefundAmount > 0" type="text" @click="refund(scope.row)">退款</el-button>
        </auth-button>
      </template>
    </Table>
    <Dialog :dialogShow="dialogShow" title="退款"  @maskClick="maskClick">
      <template>
        <el-form
          ref="refundForm"
          :model="refundForm"
          :rules="rules"
          class="refundForm"
          label-position="right"
          label-width="100px"
          :hide-required-asterisk="true"
        >
          <el-row>
            <el-col class="form-item-col" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <el-form-item label="可退款金额">
                <span class="desc-refund">¥ {{ selectRow.allowRefundAmount }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col class="form-item-col" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <el-form-item prop="amount" label="退款金额">
                <el-input
                  placeholder="请输入退款金额"
                  v-model.trim="refundForm.amount"
                  oninput="value=value.replace(/[^.\d.]/g,'')"
                  autocomplete="off"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="btn-row">
            <el-button
              class="login-btn"
              type="default"
              @click="maskClick"
            >
              取消
            </el-button>
            <el-button
              type="primary"
              @click="confirm"
              :loading="refundLoading"
            >
              确认
            </el-button>
          </el-row>
        </el-form>
      </template>
    </Dialog>
  </div>
</template>
<script>
import AuthButton from '@/components/AuthButton'
import Dialog from '@/components/Dialog/index'
import { api_getOrderPage, api_getOrderRefund } from '@/api/order'
import tableList from '@/mixins/tableList';
import Search from "@/components/Search/index";
import Table from "@/components/Table/index";
import { api_getUserPhone } from '@/api/common'
import aes from '@/common/aes.js'
export default {
  name: "OIndex",
  mixins: [tableList],
  components: {
    AuthButton,
    Search,
    Table,
    Dialog
  },
  data() {
    // 校验分摊比例
    const check = (rule, value, callback) => {
      const amount = this.refundForm.amount
      const allowRefundAmount = this.selectRow.allowRefundAmount
      if (amount > allowRefundAmount) {
        callback(new Error('退款金额不能超过可退款金额'))
      } else if (!amount){
        callback(new Error('退款金额不能为空'))
      } else {
        callback()
      }
    }
    return {
      selectRow: {
      },
      rules: {
        amount: [{required: true,  validator: check}],
      },
      refundForm: {},
      refundLoading: false,
      dialogShow: false,
      tableKey: false,
      renderData: [
        {
          label: "消费店铺",
          placeholder: "请输入消费店铺",
          type: "choose-store",
          key: "storeId",
        },
        {
          label: "会员手机号",
          placeholder: "请输入会员手机号",
          type: "input",
          key: "phone",
          maxLength: 11,
          isNumber: true
        },
        {
          label: "订单编号",
          placeholder: "请输入订单编号",
          type: "input",
          key: "paymentOrderId",
        },
        {
          label: "状态",
          placeholder: "请选择状态",
          type: "select",
          key: "status",
          option: [
            { label: "待付款", value: 'Doing', },
            { label: "已取消", value: 'Canceled', },
            { label: "已付款", value: 'PaymentSuccess', },
            { label: "已退款/部分退款", value: 'Refund', },
          ],
        },
        {
          label: "创建时间",
          placeholder: ['开始时间', '结束时间'],
          type: "date-range",
          key: "created",
        },
        {
          label: "交易流水号",
          placeholder: "请输入交易流水号",
          type: "input",
          key: "transactionId",
        },{
          label: "商场名称",
          placeholder: "请选择商场名称",
          type: "mall",
          key: "mallIds",
        },
        {
          label: "订单来源",
          placeholder: "请选择订单来源",
          type: "select",
          multiple: false,
          key: "source",
          option: [{
            value: 'WechatMiniapp',
            label: '微信小程序'
          },{
            value: 'AlipayMiniapp',
            label: '支付宝小程序'
          }],
        }
      ],
      form: {
        username: "",
        name: "",
      },
      tableThData: [
        { prop: "paymentOrderId", label: "订单编号", minWidth: "130", },
        { prop: "storeName", label: "消费店铺", minWidth: "150", },
        { prop: "mallName", label: "商场名称", minWidth: "150", },
        { prop: "phone", label: "会员手机号", minWidth: "150", },
        { prop: "amount", label: "订单金额", minWidth: "120", },
        { prop: "actualAmount", label: "实付金额", minWidth: "120", },
        { prop: "status", label: "状态", minWidth: "120", },
        { prop: "created", label: "创建时间", minWidth: "180", },
        { prop: "transactionId", label: "交易流水号", minWidth: "120", },
        { prop: "source", label: "订单来源", minWidth: "120", },
        { prop: "operation", label: "操作", minWidth: "150", },
      ]
    };
  },
  created () {
  },
  methods: {
    maskClick () {
      this.refundForm = {}
      this.dialogShow = false
    },
    refund (row) {
      this.dialogShow = true
      this.selectRow = row
      this.refundForm = {}
      this.refundLoading = false
    },
    confirm () {
      this.$refs.refundForm.validate(async (valid) => {
        if (valid) {
          this.$baseConfirm(
            '退款为敏感操作，请再次核对是否操作退款？',
            {
              title: '温馨提示',
              type: 'warning',
              cancelButtonText: '取消退款',
              confirmButtonText: '确认退款',
            },
            () => {
              this.confirmOk()
            }
          )
        } else {
          return false
        }
      })
    },

    async confirmOk() {
      this.refundLoading = true
      try {
        await api_getOrderRefund({id: this.selectRow.id, amount: this.refundForm.amount})
        this.$baseMessage('退款成功', 'success')
        this.refundLoading = false
        this.maskClick()
        this.getList()
      } catch (error) {
        this.refundLoading = false
      }
    },

    // 获取表格列表数据
    async getList () {
      this.loading = true
      const params = {
        ...this.form,
        offset: this.offset,
        limit: this.limit,
      }
      this.$router.push({query: params})
      let newParams = {...params}
      if(newParams.created && newParams.created.length > 0){
        newParams.startTime = +new Date(newParams.created[0])
        newParams.endTime = +new Date(newParams.created[1])
      }
      delete newParams.created
      // // 处理店铺数据
      // if (newParams.storeIds) {
      //   newParams.storeIds = '[' + newParams.storeIds.join(',') + ']'
      // }
      const data = await api_getOrderPage(newParams)
      console.log('data: ', data);
      this.tableTrData = data.list || []
      this.total = data.count
      this.loading = false
    },

    // 点击详情
    goDetail(row) {
      this.$router.push({
        path: "/finance/order/detail?id=" + row.id
      });
    },
    // 点击查看手机号
    async onLookPhone(row, index) {
      try {
        if (row.phone_show) {
          delete this.tableTrData[index].phone_show
        } else {
          const {phone} = await api_getUserPhone({id: row.userId})
          this.tableTrData[index].phone_show = aes.decrypt(phone)
        }
        this.tableKey = !this.tableKey
      } catch (error) {}
    },
    formatStatus (status) {
      switch (status) {
        case 'Doing':
          return '待付款'
        case 'Canceled':
          return '已取消'
        case 'PaymentSuccess':
          return '已付款'
        case 'Refund':
          return '已退款'
        case 'PartRefund':
          return '部分退款'
      }
    }
  },
  watch: {
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.order-list-index {
  width: 100%;
  padding: 0 30px;
  box-sizing: border-box;

  .fun-btn-box {
    margin-top: 20px;
  }
  .status{
    width: 6px;
    height: 6px;
    display: inline-block;
    margin-right: 5px;
  }
  .PaymentSuccess{
    background: #05c8af;
    border-radius: 50%;
    vertical-align: middle;
  }
  .Doing{
    background: #3775FF;
    border-radius: 50%;
    vertical-align: middle;
  }
  .Refund,
  .PartRefund{
    background: #F74A4A;
    border-radius: 50%;
    vertical-align: middle;
  }
  .Canceled{
    background: #F74A4A;
    border-radius: 50%;
    vertical-align: middle;
  }
  .refund{
    margin-left: 20px;
    color: #F74A4A;
  }
  .refundForm{
    margin-top: 30px;
    padding-right: 20px;
    box-sizing: border-box;
    .desc-refund{
      font-size: 16px;
      font-weight: 600;
      color: #FF6969;
    }
    .btn-row{
      padding-top: 20px;
      float: right;
      overflow: hidden;
      box-sizing: border-box;
      .el-button + .el-button{
        margin-left: 20px;
      }
      button{
        border: 0;
        width: 110px;
        height: 34px;
        padding: 0;
        line-height: 34px;
        text-align: center;
        font-size: 16px;
      }
    }
    ::v-deep {
      .el-input{
        border-radius: 2px;
        font-size: 16px;
        .el-input__inner{
          background: #F2F3F5;
        }
        .el-input__inner:focus{
          background: #fff;
          border: 1px solid #05C8AF;
        }
      }
      .el-input.is-focus{
        .el-input__inner{
          background: #fff;
        }
      }
    }
  }
}
</style>
